const resource = {
    resource_identifier_in_use: 'API 식별자 {{indicator}}가 이미 사용 중입니다',
    /** UNTRANSLATED */
    cannot_delete_management_api: 'Cannot delete Logto management API.',
};
export default Object.freeze(resource);
